export const ecommerce_sales = [
  { char: '🏷️', name: 'Price Tag', nameZh: '特價標籤', keywords: ['sale', 'discount', 'price'], hot: true },
  { char: '🛍️', name: 'Shopping Bags', nameZh: '購物戰利品', keywords: ['haul', 'shop', 'buy'], hot: true },
  { char: '🛒', name: 'Shopping Cart', nameZh: '購物車', keywords: ['cart', 'buy', 'order'] },
  { char: '📦', name: 'Package', nameZh: '包裹拆箱', keywords: ['unboxing', 'ship', 'delivery'], hot: true },
  { char: '🚚', name: 'Truck', nameZh: '快速物流', keywords: ['fast', 'delivery', 'ship'] },
  { char: '🎫', name: 'Ticket', nameZh: '優惠券', keywords: ['coupon', 'discount', 'event'] },
  { char: '💵', name: 'Dollar Bill', nameZh: '現金回饋', keywords: ['cashback', 'money'] },
  { char: '💰', name: 'Money Bag', nameZh: '省錢預算', keywords: ['save', 'budget', 'money'] },
  { char: '📢', name: 'Loudspeaker', nameZh: '大促公告', keywords: ['notice', 'sale', 'alert'] },
  { char: '🔥', name: 'Fire', nameZh: '限時瘋搶', keywords: ['hot', 'fast', 'trend'], hot: true },
  { char: '💯', name: '100', nameZh: 'CP值爆表', keywords: ['best', 'good', 'value'], hot: true },
  { char: '✨', name: 'Sparkles', nameZh: '新品上市', keywords: ['new', 'shine', 'fresh'] },
  { char: '🎁', name: 'Gift', nameZh: '滿額贈禮', keywords: ['free', 'gift', 'present'] },
  { char: '💳', name: 'Credit Card', nameZh: '刷卡分期', keywords: ['pay', 'bank', 'card'] },
  { char: '🧾', name: 'Receipt', nameZh: '下單明細', keywords: ['order', 'bill', 'list'] },
];